module.exports = __webpack_public_path__ + "img/FotoMo2.eaf90104.png";